// removed by extract-text-webpack-plugin
module.exports = {"NavigationItem":"-name__-loca-__23bcu","active":"-name__-loca-__2zJdO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItem/NavigationItem.css
// module id = 144
// module chunks = 0